import { Link } from "react-router-dom";
import { CONTACT_EMAIL, WHATSAPP_DEMO_URL } from "../../data/landingContent";
import { IconArrow } from "./icons";
import Reveal from "./Reveal";

export default function FinalCTA() {
  return (
    <section id="contact" aria-labelledby="cta-heading">
      <div className="wrap">
        <Reveal className="final-cta">
          <h2 id="cta-heading">
            See what Deepaarogya AI can do for a practice like yours
          </h2>
          <p>
            Schedule a complimentary workflow optimization consultation with our deployment engineers
            and learn why clinics are choosing to partner with Deepaarogya.
          </p>
          <div className="cta-row">
            <Link to="/demo" className="btn-primary">
              Schedule now <IconArrow />
            </Link>
            <a href={WHATSAPP_DEMO_URL} className="btn-ghost" target="_blank" rel="noopener noreferrer">
              <span className="ring" aria-hidden="true" />
              WhatsApp Us
            </a>
          </div>
          <p className="final-cta-email">
            Or email us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
